import React from "react";

export default function Navbar() {
  return (
    <>
      <div className="navbar">
        <div className="nav_container">Byte Records</div>
      </div>
    </>
  );
}
